export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-navy-50 border-t border-navy-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/234a308b2a051457e87aa49e683e124d/0c6c322b376751504e57f65121349d16.jpeg"
              alt="トイレ専門店48 forty-eight"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              「待てるのは、せいぜい2日。だから私たちは<br />
              48時間以内に伺います。」
            </p>
            <p className="text-xs text-gray-400 leading-relaxed mb-5">
              業界初の48時間以内着工保証で、<br />
              あなたのトイレの悩みを素早く解決します。
            </p>
            {/* 電話バナー */}
            <a
              href="tel:0297386660"
              className="flex items-center gap-3 bg-navy text-white rounded-xl px-4 py-3 hover:bg-navy/90 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer max-w-xs"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-accent/20 rounded-lg flex-shrink-0">
                <i className="ri-phone-fill text-accent text-lg"></i>
              </div>
              <div>
                <p className="text-white/70 text-xs leading-none mb-0.5">お電話でのご相談</p>
                <p className="font-display font-black text-white text-base leading-tight">0297-38-6660</p>
              </div>
              <span className="w-4 h-4 flex items-center justify-center ml-auto">
                <i className="ri-arrow-right-line text-white/60 text-sm"></i>
              </span>
            </a>
            <p className="text-xs text-gray-400 mt-2">9:00〜18:00（定休：日曜・木曜）</p>
          </div>

          <div>
            <h4 id="footer-service" className="font-bold text-navy text-sm mb-4">
              <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('#features'); }}>サービス</a>
            </h4>
            <ul className="space-y-2">
              {[
                { label: '48時間以内着工保証', href: '#features' },
                { label: '多能工完結施工', href: '#features' },
                { label: '厳選12プラン', href: '#plans' },
                { label: '施工の流れ', href: '#process' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    className="text-sm text-gray-500 hover:text-accent transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 id="footer-info" className="font-bold text-navy text-sm mb-4">
              <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('#about'); }}>会社情報</a>
            </h4>
            <ul className="space-y-2 mb-6">
              {[
                { label: '会社概要', href: '#about' },
                { label: '対応エリア', href: '#about' },
                { label: 'お問い合わせ', href: '#contact' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    className="text-sm text-gray-500 hover:text-accent transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-3">
              <a
                href="https://lin.ee/Su7CYDD"
                rel="nofollow"
                target="_blank"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 text-navy hover:text-accent transition-colors"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-base"></i>
              </a>
              <a
                href="https://instagram.com"
                rel="nofollow"
                target="_blank"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 text-navy hover:text-accent transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            © {currentYear} 株式会社アイリープランニング All Rights Reserved.
          </p>
          <p className="text-xs text-gray-400">
            対応エリア：つくばみらい市・守谷市・取手市
          </p>
        </div>
      </div>
    </footer>
  );
}
